import React from 'react'
import { string } from 'prop-types'

import styles from './ArticleDownload.module.scss'
import ButtonStandard from '../ButtonStandard'
import Type from '../Type'

const ArticleDownload = ({ href }) => {
  if (!href) return null
  return (
    <ButtonStandard
      iconHeight={17}
      iconWidth={14}
      icon="download"
      outline
      size="small"
      className={styles.ArticleDownload}
      href={href}
      target="_blank"
    >
      <Type className={styles.Label} size={['body2', 'body4']} weight="medium">
        Download now
      </Type>
    </ButtonStandard>
  )
}

ArticleDownload.propTypes = {
  href: string.isRequired
}

export default ArticleDownload
